import { Mapper } from '../base-mapper';
import { ActionPlanComments, ActionPlanCommentsDomain } from '../../domain';
import { ActionPlanCommentsDTO, ActionPlanCommentsItemDTO } from '../../dto';

export class ActionPlanCommentsMapper implements Mapper<ActionPlanCommentsDomain> {
	private readonly response: ActionPlanCommentsDTO;

	constructor(response: ActionPlanCommentsDTO) {
		this.response = {
			total: response.total,
			comments: Array.isArray(response.comments) ? response.comments : []
		};
	}

	private mapActionPlanItem(item: ActionPlanCommentsItemDTO): ActionPlanComments {
		return new ActionPlanComments({
			id: item.id,
			description: item.description,
			updated_at: item.updated_at ?? null,
			user: {
				id: item.user.id,
				name: item.user.name
			}
		});
	}

	toDomain(): ActionPlanCommentsDomain {
		return {
			total: this.response.total,
			comments: this.response.comments.map((item) => this.mapActionPlanItem(item))
		};
	}
}
